/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import { apiproject, apisystemsettingByCode, getOrderDetailCtrlList as _getOrderDetailCtrlList, getV2FiledSortTmplFieldList } from '@/api';
import { orderStatusMapping, statusColorMapping } from '@/constant';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Tab from "vux/src/components/tab/tab.vue"; // this line is trasformed by vux-loader
import TabItem from "vux/src/components/tab/tab-item.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import Tags from '@/components/Tags';
import OrderInfo from './OrderInfo';
import OrderBottomOptions from './OrderBottomOptions';
export default {
  components: {
    ViewBox: ViewBox,
    Tags: Tags,
    Tab: Tab,
    TabItem: TabItem,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    ServiceProcess: function ServiceProcess() {
      return import('./ServiceProcess');
    },
    OrderMessage: function OrderMessage() {
      return import('./OrderMessage');
    },
    CustomerEvaluate: function CustomerEvaluate() {
      return import('./CustomerEvaluate');
    },
    OrderExecute: function OrderExecute() {
      return import('./OrderReturnReceipt/OrderExecute');
    },
    OrderInfo: OrderInfo,
    ServiceAmount: function ServiceAmount() {
      return import('./ServiceAmount');
    },
    DetailCtrlList: function DetailCtrlList() {
      return import('./DetailCtrlList');
    },
    OrderBottomOptions: OrderBottomOptions,
    ProductInfo: function ProductInfo() {
      return import('./ProductInfo');
    }
  },
  props: {
    oid: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      orderService: {},
      orderStatusMapping: orderStatusMapping,
      statusColorMapping: statusColorMapping,
      orderInfo: {},
      template: {},
      // 模板信息
      abnormalOrder: {},
      orderProduct: {},
      orderExtFields: [],
      remarkPicList: [],
      orderServiceNodes: [],
      serviceTreeMap: {},
      evaluatePicList: [],
      moneyItemEditRoles: [],
      examineUsers: [],
      detailCtrlList: [],
      is_view_settlement: 0,
      is_view_receipt: 0,
      tabsIndex: 0,
      tagLineShow: false,
      // 客户id
      customerId: 0,
      custtomShow: false,
      // 工单标签
      taglist: [],
      address: '',
      reloadflag: false,
      isEditCoordination: false,
      // 是否开启编辑协同人
      sourceIcon: {
        2: 'icon_h532_32@3x',
        3: 'icon_wechat32_32@3x',
        7: 'icon_ding32_32@3x'
      },
      isShowOrderMessage: 0,
      isServiceAmount: false,
      sortList: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    hasAuth: function hasAuth() {
      // 有权限操作工单
      return this.orderInfo.fk_t_ep_home_parent_account_id === this.user.id || this.orderInfo.fk_t_ep_home_children_account_id === this.user.id;
    },
    orderState: function orderState() {
      if (this.isRefuse) {
        return i18n.tc("10");
      }
      return this.orderStatusMapping.get("".concat(this.orderInfo.state, "_").concat(this.orderInfo.evaluate_state));
    },
    isRefuse: function isRefuse() {
      return this.orderInfo.is_refuse_acceptance === 1;
    },
    isServiceProcess: function isServiceProcess() {
      return [2, 3, 4, 5, 6].indexOf(this.orderInfo.state) !== -1;
    },
    isOrderReceipt: function isOrderReceipt() {
      return [5].indexOf(this.orderInfo.state) !== -1 &&
      // 完成工单
      this.orderInfo.is_customer_view_receipt === 1; // 客户回执可见
    },
    isOrderMessage: function isOrderMessage() {
      return [0, 1, 2, 3, 4, 5, 6].indexOf(this.orderInfo.state) !== -1;
    },
    isCustomerEvaluate: function isCustomerEvaluate() {
      return [5, 6].indexOf(this.orderInfo.state) !== -1;
    },
    isShowProductInfo: function isShowProductInfo() {
      return this.sortList.find(function (v) {
        return v.field_key === 'orderCustomerPro';
      });
    },
    tabs: function tabs() {
      var tabs = [i18n.tc("539")];
      if (this.isServiceAmount) tabs.push(i18n.tc("540"));
      if (this.isServiceProcess) tabs.push(i18n.tc("399"));
      if (this.isOrderReceipt) tabs.push(i18n.tc("136"));
      if (this.isOrderMessage) tabs.push(i18n.tc("135"));
      if (this.isCustomerEvaluate) tabs.push(i18n.tc("527"));
      if (this.isShowProductInfo) tabs.push(i18n.tc("667"));
      this.detailCtrlList.forEach(function (item) {
        tabs.push(item.name);
      });
      return tabs;
    },
    processList: function processList() {
      var acceptTime = '';
      if (this.orderInfo.is_acceptance === 0 || this.orderInfo.is_refuse_acceptance === 1) {
        acceptTime = this.orderInfo.take_order_time || '';
      } else {
        acceptTime = this.orderInfo.acceptance_time || '';
      }
      var front = [{
        title: i18n.tc("541"),
        time: this.orderInfo.take_order_time,
        finish: this.orderInfo.state >= 0
      }, {
        title: i18n.tc("542"),
        time: acceptTime,
        finish: [0, 1, 2, 3, 4, 5].indexOf(this.orderInfo.state) !== -1
      }];
      var back = this.isRefuse ? [{
        title: i18n.tc("543"),
        time: this.orderInfo.acceptance_time || '',
        finish: [0, 2].indexOf(this.orderInfo.state) !== -1 && this.isRefuse
      }] : [{
        title: i18n.tc("544"),
        time: this.orderInfo.sign_time1 || '',
        finish: [4, 5].indexOf(this.orderInfo.state) !== -1
      }, {
        title: i18n.tc("545"),
        time: this.orderInfo.sign_time2 || '',
        finish: this.orderInfo.state === 5
      }];
      return front.concat(back);
    }
  }),
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    initFieldList: function initFieldList(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getV2FiledSort, _yield$getV2FiledSort2, newData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (id) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.next = 4;
                return getV2FiledSortTmplFieldList({
                  tmplId: id,
                  type: 2
                });
              case 4:
                _yield$getV2FiledSort = _context.sent;
                _yield$getV2FiledSort2 = _yield$getV2FiledSort.data;
                newData = _yield$getV2FiledSort2 === void 0 ? [] : _yield$getV2FiledSort2;
                _this.sortList = newData;
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSuccessBottomBtn: function onSuccessBottomBtn(key) {
      var _this2 = this;
      var action = {
        message: function message() {
          return _this2.$refs.orderMessage.reload(true);
        },
        evaluate: function evaluate() {
          return _this2.$refs.customerEvaluate.reload();
        }
      };
      this.reload();
      this._pageReload({
        order: true
      });
      action[key] && action[key]();
    },
    location: function location() {
      if (!this.orderInfo) return;
      if (this.orderInfo.custom_latitude === 0 || this.orderInfo.custom_longitude === 0) {
        this.$vux.toast.text(i18n.tc("546"));
      } else {
        this.$DingTalk && this.$DingTalk.biz.map.view({
          latitude: this.orderInfo.custom_latitude,
          // 纬度
          longitude: this.orderInfo.custom_longitude,
          // 经度
          title: this.orderInfo.gps_addr
        });
        // this.$DingTalk.biz.map.locate({
        //   latitude: this.orderInfo.custom_latitude, // 纬度
        //   longitude: this.orderInfo.custom_longitude, // 经度
        //   onSuccess: (res) => {

        //   },
        //   onFail: (e) => {
        //   }
        // })
      }
    },
    tel: function tel(phone) {
      this.$DingTalk && this.$DingTalk.biz.telephone.showCallMenu({
        phoneNumber: phone,
        // 期望拨打的电话号码
        code: '+86',
        // 国家代号，中国是+86
        showDingCall: true,
        // 是否显示钉钉电话
        onSuccess: function onSuccess() {},
        onFail: function onFail() {}
      });
    },
    message: function message() {},
    pushDetail: function pushDetail() {
      // if (this.orderInfo && this.orderInfo.fk_t_customer_id) {
      //   this.$router.push({name: 'CustomerDetail', params: { customerId: this.orderInfo.fk_t_customer_id }})
      // } else {
      //   this.$vux.toast.text('此客户不存在')
      // }
    },
    reload: function reload(flag) {
      var _this3 = this;
      apiproject({
        oid: this.oid
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res1) {
          var sortIndex, orderExtFields;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!res1.success) {
                    _context2.next = 16;
                    break;
                  }
                  _this3.orderInfo = res1.data.orderMap;
                  _this3.remarkPicList = res1.data.image_descri_list || [];
                  _this3.serviceTreeMap = res1.data.serviceTreeMap;
                  _this3.orderServiceNodes = res1.data.processNodeList;
                  _this3.coordList = res1.data.coordList || [];
                  _this3.template = res1.data.orderTmpl;
                  _this3.orderService = res1.data.moneyItemList;
                  _this3.orderProduct = res1.data.orderProduct;
                  // this.abnormalOrder = res1.data.abnormalOrder
                  // this.taglist = res1.data.orderInfo.tags
                  // this.evaluatePicList = res1.data.evaluatePicList
                  _this3.moneyItemEditRoles = res1.data.moneyItemEditRoles;
                  // this.examineUsers = res1.data.examineUsers
                  _context2.next = 12;
                  return _this3.initFieldList(res1.data.orderMap.id);
                case 12:
                  sortIndex = _this3.sortList.filter(function (v) {
                    return !v.is_system;
                  });
                  orderExtFields = res1.data.orderFiledlist || [];
                  try {
                    orderExtFields.sort(function (f, b) {
                      return sortIndex.findIndex(function (v) {
                        return +v.field_key === f.id;
                      }) - sortIndex.findIndex(function (v) {
                        return +v.field_key === b.id;
                      });
                    });
                  } catch (e) {
                    console.log('AutoConsole: reload -> e', e);
                  }
                  _this3.orderExtFields = orderExtFields;
                case 16:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    editcount: function editcount() {
      this.$refs['serviceAmount'].load();
      this.reload();
    },
    orderexecute: function orderexecute() {
      this.reload();
      this.$refs['orderBottomOptions'].loadEditAmount();
      this.$refs['serviceAmount'].load();
    },
    serviceamount: function serviceamount() {
      this.reload();
      this.reloadflag = true;
      if (this.$refs['serviceAmount']) {
        this.$refs['serviceAmount'].load();
      }
    },
    getOrderDetailCtrlList: function getOrderDetailCtrlList() {
      var _this4 = this;
      _getOrderDetailCtrlList({
        oid: this.oid
      }).then(function (res) {
        if (res.success) _this4.detailCtrlList = res.data || [];
      });
    }
  }),
  created: function created() {
    var _this5 = this;
    apisystemsettingByCode({
      code: 40006
    }).then(function (res) {
      if (res.success && res.data) {
        _this5.isServiceAmount = Boolean(+res.data.value);
      }
    });
    this.getOrderDetailCtrlList();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    apiproject({
      oid: to.params.oid
    }).then(function (res1) {
      next( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(vm) {
          var sortIndex, orderExtFields;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!res1.success) {
                    _context3.next = 15;
                    break;
                  }
                  vm.orderInfo = res1.data.orderMap;
                  // vm.orderExtFields = res1.data.orderFiledlist || []
                  vm.remarkPicList = res1.data.image_descri_list || [];
                  vm.serviceTreeMap = res1.data.serviceTreeMap;
                  vm.orderServiceNodes = res1.data.processNodeList;
                  vm.coordList = res1.data.coordList || [];
                  vm.template = res1.data.orderTmpl;
                  vm.orderService = res1.data.moneyItemList;
                  vm.orderProduct = res1.data.orderProduct;
                  // vm.abnormalOrder = res1.data.abnormalOrder
                  // vm.taglist = res1.data.orderInfo.tags
                  // vm.evaluatePicList = res1.data.evaluatePicList
                  // vm.moneyItemEditRoles = res1.data.moneyItemEditRoles
                  // vm.examineUsers = res1.data.examineUsers
                  _context3.next = 11;
                  return vm.initFieldList(res1.data.orderMap.id);
                case 11:
                  sortIndex = vm.sortList.filter(function (v) {
                    return !v.is_system;
                  });
                  orderExtFields = res1.data.orderFiledlist || [];
                  try {
                    orderExtFields.sort(function (f, b) {
                      return sortIndex.findIndex(function (v) {
                        return +v.field_key === f.id;
                      }) - sortIndex.findIndex(function (v) {
                        return +v.field_key === b.id;
                      });
                    });
                  } catch (e) {
                    console.log('AutoConsole: reload -> e', e);
                  }
                  vm.orderExtFields = orderExtFields;
                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next();
  }
};